import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import "../index.css";
import "./index.css";
import TopMenu from "../Layout/TopMenu";
import MenuDesktop from "../Layout/MenuDesktop";
import { MDBRow, MDBCol } from "mdbreact";
import { IoSearch } from "react-icons/io5";
import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
} from "react-icons/ri";
import NavBar from "../Layout/NavBar";
import mixpanel from "mixpanel-browser";
import { HiLightningBolt, HiSortAscending } from "react-icons/hi";

import { firebase } from "../../../firebase/config";

import { TiTick } from "react-icons/ti";
import VisibilitySensor from "react-visibility-sensor";
import Scroll from "react-scroll";
import Footer from "../Layout/Footer";
import Job from "./Job";

const jobs = [
  {
    line1:
      "We believe that the way youtube channels grow will drastically improve in the next few years. We’re dedicated to empowering this transformation by building the tools and experiences that youtube channels can use. Founded in 2023, the company is headquartered in New York.",
    line2:
      "Our ability to support new products, and customers rests on the quality of the internal platform, abstractions, and APIs that we build. The better common building blocks we create, the faster we enable other engineering teams to build and scale each product for our customers and our users.",
    line3:
      "We are hiring a Software Engineer to build out our abstractions team, which provides common abstractions and primitives. For example, the creation of a single external API route can require the ability to permission, schedule updates to, retrieve, and send notifications about dubbing tasks that we deliver to youtube channel customers.",
    line4:
      "As an engineer, you’ll help build, scale, and design the next generation of YouDub's product infrastructure. Our engineering culture is IC-driven—we favor bottom-up ideation and empowerment of our incredibly talented team.",
    a: "Building products with real impact: your work will touch millions of end-users.",
    b: "Scaling YouDub's core data models and data permissioning systems",
    c: "Building the product engineering teams and designing the right backend abstractions while making pragmatic tradeoffs",
    d: "5+ years of experience with backend work/database scaling/API Design scaling/API Design",
    e: "Experience with APIs, scalability, and performance",
    f: "Empathy and enthusiasm for understanding other teams challenges",
  },
  {
    line1:
      "We believe that the way youtube channels grow will drastically improve in the next few years. We’re dedicated to empowering this transformation by building the tools and experiences that youtube channels can use. Founded in 2023, the company is headquartered in New York.",

    line2:
      "FrontEnd Engineering is a highly cross-functional team dedicated to building the best dubbing experience and user flows needed to ensure a smooth experience, and ensure YouDub's customers are providing the best experience to their viewers.",
    line3:
      "In this role, you will be responsible for building new frontend experiences for the platform, as well as improving the existing platform.",
    line4:
      "You’ll build the core YouDub team to define and implement new UI libraries as our business evolves and new trends surface.",
    a: "Building products with real impact: your work will touch millions of end-users.",
    b: "Scaling YouDub's UI library and design systems",
    c: "Building the frontend teams and designing the right UI components while making pragmatic tradeoffs",
    d: "4+ years of industry experience building customer facing products.",
    e: "Understanding and prioritizing risk vectors quantitatively.",
    f: "Successful projects across the frontend engineering stack at scale.",
  },
  {
    line1:
      "We believe that the way youtube channels grow will drastically improve in the next few years. We’re dedicated to empowering this transformation by building the tools and experiences that youtube channels can use. Founded in 2023, the company is headquartered in New York.",

    line2:
      "The ML Engineering team is tasked with scaling our ML models whilst minimising costs and downtime of YouDub.",
    line3: "You'll build the ML Engineering team from the ground up.",
    line4:
      "On this team you will be responsible for identifying and advocating for solution that best meet the needs of the company.",
    a: "Using software driven solution to solve Cloud Engineering or DevOps problems.",
    b: "Working with various engineering teams to achieve common goals",
    c: "Doing a little bit of everything across our entire stack and across teams to ensure the success of YouDub and our customers",
    d: "Experience with Kubernetes (or a similar container orchestration system)",
    e: "Experience with Terraform",
    f: "Experience with cloud infrastructure, AWS preferred.",
  },
  {
    line1:
      "We believe that the way youtube channels grow will drastically improve in the next few years. We’re dedicated to empowering this transformation by building the tools and experiences that youtube channels can use. Founded in 2023, the company is headquartered in New York.",
    line2:
      "YouDub's Inside Sales Team is focusing on discovering new youtube channels that can benefit from our platform. Our work helps YouDub build delightful and innovative products, make better decisions, understand and manage risks, and creatively navigate challenges, both external and internal. ",
    line3:
      "We’re looking for an Inside Sales Rep to join our Team! In this role, you’ll work closely with Product, Engineering, Design, Marketing and many other teams to understand and assess new products, from early development stages through launch, and help scale existing products. You’ll operate as an embedded member of the product team and be trusted to be a key voice of the customer.",
    line4:
      "The ideal candidate will be a highly collaborative, inquisitive, and solutions-oriented sales rep with prior experience advising on product development at a fast moving technology company. Experience in hiring platforoms is great, but not required, for you to be successful in this role. ",
    a: "Providing pragmatic, creative, and strategic advice to product teams on novel product challenges.",
    b: "Collaborating closely with a wide variety of teams at YouDub, including Product, Engineering, Revenue, Compliance, Risk and Marketing, on complex customer challenges related to product development and commercialization.",
    c: "Building strong relationships with product and business colleagues and operating as a trusted advisor to help them ship great products",
    d: "You have 4+ years doing B2B SaaS sales.",
    e: "You’re a creative thinker who is comfortable interpreting customer feedback, and you love seeing around corners and connecting dots.",
    f: "You’re highly collaborative and are dedicated to developing strong relationships with key business partners.",
  },
  {
    line1:
      "We believe that the way youtube channels grow will drastically improve in the next few years. We’re dedicated to empowering this transformation by building the tools and experiences that youtube channels can use. Founded in 2023, the company is headquartered in New York.",

    line2:
      "The Product Team at YouDub enable’s our business to scale and accelerates product development by allowing our engineering teams to focus on building the future of youtube dubbing. It’s a deeply technical team responsible for the foundational building blocks that reduce the burden of infrastructure ownership at YouDub, including cloud services, developer tooling, data and machine learning platforms, domain abstractions, and common components across all product lines. ",
    line3:
      "We are looking for an experienced product leader to drive product vision and strategy for our Product Team. This leader will build and develop a high performing PM team that deeply understands our customers’ needs, prioritizes the most important opportunities for us to explore, and measures our success effectively.",
    line4:
      "Product Management is a new function and team, which means you’ll help to shape the vision, culture, and practices for this vital function at YouDub. If you’re looking for a deeply technical and dynamic opportunity that will have an outsized impact on the future of skills based hiring, we’d love to talk to you!",
    a: "Partnering with our engineering team to drive product vision and strategy across our infrastructure, developer tooling, and platform offerings at YouDub",
    b: "Deeply understanding the needs of product development teams at YouDub",
    c: "Fostering an environment that is customer-focused, data-driven, and experimentation based",
    d: "A deep understanding of platforms and creating building blocks.",
    e: "Experience building, coaching, and retaining high performing, diverse teams of PMs",
    f: "Demonstrable understanding of cloud infrastructure, developer tooling, and/or data/ML platforms at scale",
  },
];
class Intro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      querySellers: [],
    };
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  openModal = () => {
    this.setState({ signUp: true, isNavbar: false });
  };

  componentDidMount() {
    firebase
      .firestore()
      .collection("sellers")
      .orderBy("level", "desc")
      .limit(6)
      .get()
      .then((querySnapshot) => {
        let empty = [];
        querySnapshot.forEach((doc) => {
          empty.push(doc.data());
        });
        this.setState({ sellers: empty, querySellers: empty });
      });
  }

  render() {
    console.log(this.props.version);
    return (
      <>
        <MDBCol
          className="backy26"
          style={{
            width: "100vw",
            overflowX: "hidden",
            color: "white",
          }}
          size="12"
        >
          <MDBRow className="HeroSection">
            <MenuDesktop color="light" />
            <MDBCol size="12">
              <MDBRow style={{ paddingBottom: "5vh" }}>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      fontSize: 13,
                      marginTop: 40,
                      textAlign: "center",
                      opacity: 1,
                      color: "#FF0000",
                    }}
                  >
                    JOBS AT YOUDUB
                  </p>
                </MDBCol>
                <MDBCol
                  style={{ marginTop: -30 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p style={{ color: "white" }} className="HeroHeading">
                    Let's build the future of
                    <br />
                    Youtube Dubbing together
                  </p>
                </MDBCol>
                <MDBCol
                  style={{ color: "white" }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p style={{ width: "50%" }} className="HeroSubHeading">
                    We believe in empowering youtubers. Whatever their size, we
                    want to help them grow and succeed. Whether its localizing
                    to new languages or more. We're looking for ambitious people
                    to join us.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <NavLink
                    exact
                    to="/about"
                    className="d-flex justify-content-center"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex HeroButton lightButton justify-content-center"
                      style={{
                        borderRadius: 200,
                        paddingTop: 10,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 17,
                        width: 170,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      Our mission
                    </div>
                  </NavLink>
                </MDBCol>
                <MDBCol
                  style={{ marginTop: 10 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "white",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{" "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        color: "#FF0000",
                        textDecoration: "underline",
                      }}
                    >
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>

          <MDBRow
            style={{
              paddingBottom: "12vh",
              backgroundColor: "#F5F5F5",
              color: "black",
              width: "100vw",
              paddingLeft: "10%",
            }}
          >
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSExtraBold",
                  fontSize: 29,
                  marginTop: 65,
                  lineHeight: 1.3,
                  width: "100%",
                }}
              >
                Engineering
              </p>
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "black",
                  opacity: 0.7,
                  fontSize: 17,
                  width: "60%",
                  marginTop: 0,
                  opacity: 0.7,
                }}
              >
                We build simple yet innovative experiences that shape how
                youtube channels reach new audiences.
              </p>
            </MDBCol>

            <Job
              jobs={jobs[0]}
              category="Engineering"
              title="Experienced Software Engineer - Core Platform"
            />
            <Job
              jobs={jobs[1]}
              category="Engineering"
              title="Experienced Software Engineer - FrontEnd Engineer"
            />
            <Job
              jobs={jobs[2]}
              category="Engineering"
              title="ML Engineer - Voice Conversion"
            />

            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSExtraBold",
                  fontSize: 29,
                  marginTop: 65,
                  lineHeight: 1.3,
                  width: "100%",
                }}
              >
                Sales
              </p>
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "black",
                  opacity: 0.7,
                  fontSize: 17,
                  width: "60%",
                  marginTop: 0,
                  opacity: 0.7,
                }}
              >
                We have ambitious goals and we're looking to work with great
                inside sales reps to scale YouDub to more youtubers.
              </p>
            </MDBCol>

            <Job jobs={jobs[3]} category="Sales" title="Inside Sales" />

            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSExtraBold",
                  fontSize: 29,
                  marginTop: 65,
                  lineHeight: 1.3,
                  width: "100%",
                }}
              >
                Product
              </p>
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "black",
                  opacity: 0.7,
                  fontSize: 17,
                  width: "60%",
                  marginTop: 0,
                  opacity: 0.7,
                }}
              >
                We evaluate what to pursue, craft experiences to maximize
                customer delight, and help youtube channels grow their business.
              </p>
            </MDBCol>

            <Job
              jobs={jobs[4]}
              category="Product"
              title="Head of Product - Platform"
            />
          </MDBRow>

          <MDBRow>
            <div
              className="pattern2"
              style={{
                height: 400,
                width: "100vw",
                backgroundRepeat: "repeat",
              }}
            >
              <MDBRow>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSExtraBold",
                      fontSize: 29,
                      color: "black",
                      marginTop: 100,
                      lineHeight: 1.3,
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Excited to join our mission?
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      opacity: 0.7,
                      fontSize: 16,
                      width: "30%",
                      marginTop: 0,
                      textAlign: "center",
                      opacity: 0.7,
                    }}
                  >
                    We're assembling a team of wonderful people that love
                    solving hard problems and working together.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <NavLink
                    to="/about"
                    exact
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex HeroButton lightButton   justify-content-center"
                      style={{
                        backgroundColor: "#FF0000",
                        borderRadius: 200,
                        paddingTop: 10,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 17,
                        width: 170,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      Read more
                    </div>
                  </NavLink>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{" "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        color: "#FF0000",
                        textDecoration: "underline",
                      }}
                    >
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBRow>
        </MDBCol>
        <div className="HeroSection">
          <Footer />
        </div>
      </>
    );
  }
}

export default withRouter(Intro);
